module.exports = __webpack_public_path__ + "img/600x600.71624c25.png";